/**
 * Read-only mode.
 *
 * When the platform suspends a tenant (CLAUDE.md §10) the API answers every
 * write with `ERR_TENANT_SUSPENDED`. Rather than let a user fill in a form and
 * lose the work to a 403, the app notices the first such answer and puts every
 * write affordance out of reach behind an explanation banner.
 *
 * This is a courtesy, not a control: the server refuses the write regardless.
 */

import { computed, type ComputedRef } from 'vue'

import { tenantSuspended } from '@/api/client'
import { t } from '@/i18n'

export interface ReadOnlyState {
  readOnly: ComputedRef<boolean>
  /** Sentence to show on a disabled control's tooltip. */
  reason: ComputedRef<string>
}

export function useReadOnly(): ReadOnlyState {
  return {
    readOnly: computed(() => tenantSuspended.value),
    reason: computed(() => (tenantSuspended.value ? t('shell.readOnly.reason') : '')),
  }
}
